import { render, staticRenderFns } from "./BookingHandle.vue?vue&type=template&id=1bf56332&"
import script from "./BookingHandle.vue?vue&type=script&lang=js&"
export * from "./BookingHandle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports